import React from 'react';
import {
	NavLink,
	Link
} from 'react-router-dom'

import Logo from './../inc/Logo';
import LogoSVG from './../inc/LogoSVG';

class Menu extends React.Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this)
	}

	componentDidMount() {
		
		// adjust fullscreen height
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
		window.addEventListener('resize', () => {
			let vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${vh}px`);
		});


		let mainMenus = document.querySelectorAll('.main-menu');
		let mainMenuliA = document.querySelectorAll('.main-menu > li > a');
		let subMenuliA = document.querySelectorAll('.sub-menu > li > a');
		let submenus = document.querySelectorAll('.sub-menu');


		mainMenuliA.forEach(liA => {
			liA.addEventListener('mouseover', () => {
				// fade all siblings
				for (let sibling of liA.parentNode.parentNode.children) { 
					if (sibling !== liA.parentNode) sibling.classList.add('fade-in');
				 }

				// unfade this
				liA.parentNode.classList.remove('fade-in');


				// hide all submenu
				for (let submenu of submenus) { submenu.style['display'] = "none"; }

				// if it has submenu then show
				if (liA.nextElementSibling) liA.nextElementSibling.style['display'] = "inline-block";
			});
		});


		subMenuliA.forEach(liA => {
			liA.addEventListener('mouseover', () => {
				// fade all siblings
				for (let sibling of liA.parentNode.parentNode.children) { 
					if (sibling !== liA.parentNode) sibling.classList.add('fade-in');
				}

				// unfade this
				liA.parentNode.classList.remove('fade-in');
			});

			liA.addEventListener('mouseleave', () => {
				for (let sibling of liA.parentNode.parentNode.children) { 
					sibling.classList.remove('fade-in');
				}
			});
		});
	
		


		// footer hightlight on contact hover
		let contactLinks = document.querySelectorAll('.nav-contact');
		contactLinks.forEach(contactLink => {
			contactLink.addEventListener('mouseover', () => {
				contactLink.closest('.mole__menu').querySelector('.mole__menu--footer').classList.add('white');
			});
	
			contactLink.addEventListener('mouseleave', () => {
				contactLink.closest('.mole__menu').querySelector('.mole__menu--footer').classList.remove('white');
			});
		});




		
		// reset to default of mouseleave from menu
		mainMenus.forEach(mainMenu => {
			mainMenu.addEventListener('mouseleave', () => {
				for (let submenu of submenus) { submenu.style['display'] = "none"; }
				for (let li of mainMenu.querySelectorAll('li')) { li.classList.remove('fade-in')}
			});	
		});


		// change icon
		window.addEventListener('scroll', () => {
			if(!document.querySelector('#fullpage')){
				let viewportTop = window.scrollY;
				let footerElem = document.querySelector('footer .mole__menu');
				let moleMenu = document.querySelector('main .mole__menu');
				let menuBtn = document.querySelector('header .btn-menu');
				if(footerElem.offsetTop){
					(viewportTop >= footerElem.offsetTop) ? menuBtn.classList.add('only-') : menuBtn.classList.remove('only-');
				}
				else if(moleMenu.offsetTop){
					(viewportTop >= moleMenu.offsetTop) ? menuBtn.classList.add('only-') : menuBtn.classList.remove('only-');
				}
				
			}
		});
		
	}

	handleClick(e){
		console.log(e)
        const root = document.getElementsByTagName('html')[0];
        root.classList.toggle('bound');
        root.classList.toggle('menu-open');
    }


	render() {
		let {
            twitter_url, 
            instagram_url, 
            linkedin_url, 
            contact_number, 
            contact_email, 
            copyright, 
            vat, 
            company_reg_no, 
            office_address,
            logo_image
        } = this.props.options.options;
		return (
			<nav>
				<div className="mole__menu fullW" style={{backgroundColor: '#f68e1e'}}>
					<div className="main-container">
						<div className="inner-container">
							<NavLink className="home-link" exact to={`${process.env.PUBLIC_URL}`}><LogoSVG/></NavLink>
							
							<ul className="main-menu menu__all">
								<li className="has-submenu">
									<NavLink activeClassName="nav-actv" exact to={`${process.env.PUBLIC_URL}/project/grid/selected`}>Projects</NavLink>
									<ul className="sub-menu">
										<li><NavLink activeClassName="nav-actv" onClick={this.handleClick} exact to={`${process.env.PUBLIC_URL}/project/grid/selected`}>Selected</NavLink></li>
										<li><NavLink activeClassName="nav-actv" onClick={this.handleClick} exact to={`${process.env.PUBLIC_URL}/project/grid`}>All</NavLink></li>
                                        <li><NavLink activeClassName="nav-actv" onClick={this.handleClick} exact to={`${process.env.PUBLIC_URL}/project/grid/community`}>Community</NavLink></li>
                                        <li><NavLink activeClassName="nav-actv" onClick={this.handleClick} exact to={`${process.env.PUBLIC_URL}/project/grid/house`}>House</NavLink></li>
                                        <li><NavLink activeClassName="nav-actv" onClick={this.handleClick} exact to={`${process.env.PUBLIC_URL}/project/grid/housing`}>Housing</NavLink></li>
                                        <li><NavLink activeClassName="nav-actv" onClick={this.handleClick} exact to={`${process.env.PUBLIC_URL}/project/grid/workspace`}>Workspace</NavLink></li>
									</ul>
								</li>
								<li><NavLink activeClassName="nav-actv" exact to={`${process.env.PUBLIC_URL}/values`}>Values</NavLink></li>
								<li><NavLink activeClassName="nav-actv" exact to={`${process.env.PUBLIC_URL}/services`}>Services</NavLink></li>
								<li className="has-submenu">
									<NavLink activeClassName="nav-actv" exact to={`${process.env.PUBLIC_URL}/about`}>About</NavLink>
									<ul className="sub-menu">
										{/* <li><NavLink activeClassName="nav-actv" onClick={this.handleClick} exact to={`${process.env.PUBLIC_URL}/about#values`}>Values</NavLink></li> */}
										{/* <li><NavLink activeClassName="nav-actv" onClick={this.handleClick} exact to={`${process.env.PUBLIC_URL}/about#services`}>Services</NavLink></li> */}
										<li><NavLink activeClassName="nav-actv" onClick={this.handleClick} exact to={`${process.env.PUBLIC_URL}/about#team`}>Team</NavLink></li>
										<li><NavLink activeClassName="nav-actv" onClick={this.handleClick} exact to={`${process.env.PUBLIC_URL}/about#awards`}>Awards</NavLink></li>
										<li><NavLink activeClassName="nav-actv" onClick={this.handleClick} exact to={`${process.env.PUBLIC_URL}/about#press`}>Press</NavLink></li>
										<li><NavLink activeClassName="nav-actv" onClick={this.handleClick} exact to={`${process.env.PUBLIC_URL}/about#catalogues`}>Catalogues</NavLink></li>
										<li><NavLink activeClassName="nav-actv" onClick={this.handleClick} exact to={`${process.env.PUBLIC_URL}/about#published`}>Published</NavLink></li>
									</ul>
								</li>
								{/* <li><NavLink activeClassName="nav-actv" exact to={`${process.env.PUBLIC_URL}/team`}>Team</NavLink></li> */}
								<li>
									<NavLink activeClassName="nav-actv" exact to={`${process.env.PUBLIC_URL}/journal`}>Journal</NavLink>
									{/* <ul className="sub-menu">
										<li><NavLink activeClassName="nav-actv" exact to={`${process.env.PUBLIC_URL}/journal`}>Option1</NavLink></li>
										<li><NavLink activeClassName="nav-actv" exact to={`${process.env.PUBLIC_URL}/journal/op2`}>Option2</NavLink></li>
									</ul> */}
								</li>
								<li><a href="javascript:" className="nav-contact">Contact</a></li>
							</ul>
							<div className="mole__menu--footer">
								<address dangerouslySetInnerHTML={{__html:office_address}} />
								
								<address>
									<p><a href="tel:01223913012">{contact_number}</a></p>
									<p><a href={`mailto:${contact_email}`}>Email</a></p>
									<p><a href={instagram_url} target="_blank">Instagram</a></p>
									<p><a href={twitter_url} target="_blank">Twitter</a></p>
									<p><a href={linkedin_url} target="_blank">LinkedIn</a></p>
									<p></p>
									<p className="fade-in-link"><Link exact to={`${process.env.PUBLIC_URL}/credits`}>Credits</Link></p>
								</address>

								<article>
									<p>Company Registration No. <br/>{company_reg_no}</p>
									<br/>
									<p>VAT No. <br/>{vat}</p>
								</article>
							</div>
						</div>
					</div>
				</div>
			</nav>
		);
	}
}
export default Menu;


// WEBPACK FOOTER //
// ./src/components/inc/Menu.js